import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import toast from 'react-hot-toast';
import { songAPI } from '../services/api';

const PageContainer = styled.div`
  padding: 2rem;
  min-height: 60vh;
`;

const SongGrid = styled.div`
  display: grid;
  gap: 1rem;
  
  @media (min-width: 768px) {
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  }
`;

const SongCard = styled.div`
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(204, 0, 0, 0.2);
  border-radius: 6px;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(255, 255, 255, 0.05);
    border-color: #cc0000;
    transform: translateY(-2px);
  }
`;

const SongRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
`;

const SongName = styled.h3`
  color: #ffffff;
  font-size: 1.1rem;
  margin: 0;
  font-weight: 600;
  flex: 1;
`;

const CurrentAmount = styled.div`
  font-size: 1.5rem;
  font-weight: 700;
  color: #cc0000;
  text-align: right;
  min-width: 60px;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 3rem;
  color: #999;
`;

const LoadingSpinner = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 3rem;
  
  &::after {
    content: '';
    width: 40px;
    height: 40px;
    border: 4px solid #444;
    border-top: 4px solid #cc0000;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

function ExternalHomePage() {
  const [songs, setSongs] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Load all songs (including archived)
  useEffect(() => {
    loadSongs();
  }, []);

  const loadSongs = async () => {
    try {
      setLoading(true);
      const allSongs = await songAPI.getSongs('', 'name', 'ASC');
      setSongs(allSongs);
    } catch (error) {
      console.error('Error loading songs:', error);
      toast.error('Failed to load songs');
    } finally {
      setLoading(false);
    }
  };

  const handleSongClick = (songId) => {
    navigate(`/external/song/${songId}`);
  };

  if (loading) {
    return (
      <PageContainer>
        <LoadingSpinner />
      </PageContainer>
    );
  }

  return (
    <PageContainer>
      {songs.length === 0 ? (
        <EmptyState>
          <h3>No songs found</h3>
        </EmptyState>
      ) : (
        <SongGrid>
          {songs.map((song) => (
            <SongCard 
              key={song.id} 
              onClick={() => handleSongClick(song.id)}
              style={{ opacity: song.status === 'archived' ? 0.5 : 1 }}
            >
              <SongRow>
                <SongName style={{ color: song.status === 'archived' ? '#888' : '#ffffff' }}>
                  {song.name}
                </SongName>
                <CurrentAmount style={{ color: song.status === 'archived' ? '#666' : '#cc0000' }}>
                  {song.current_amount}
                </CurrentAmount>
              </SongRow>
            </SongCard>
          ))}
        </SongGrid>
      )}
    </PageContainer>
  );
}

export default ExternalHomePage;

















